import { createFileRoute } from '@tanstack/react-router';
import { LandingPage } from '@/features/public/LandingPage';
import { publicHead } from '@/features/public/PublicLayout';

export const Route = createFileRoute('/')({
  head: () =>
    publicHead(
      'Powered sites and datacenter capacity, introduced',
      'Describe the power, region and timing you need. We check fit with the site side and introduce you when both want to talk.',
    ),
  component: LandingPage,
});
